import logoAccordEmv from 'url:../../../../../resource/images/logoAccordEmv.png';
import logoAlma from 'url:../../../../../resource/images/logoAlma.png';
import logoAmericanExpress from 'url:../../../../../resource/images/logoAmericanExpress.png';
import logoAmericanExpressSansContact from 'url:../../../../../resource/images/logoAmericanExpressSansContact.png';
import logoAurore from 'url:../../../../../resource/images/logoAurore.png';
import logoCashAgence from 'url:../../../../../resource/images/logoCashAgence.png';
import logoCB from 'url:../../../../../resource/images/logoCB.png';
import logoCBSansContact from 'url:../../../../../resource/images/logoCBSansContact.png';
import logoCbVad from 'url:../../../../../resource/images/logoCbVad.png';
import logoCbConecs from 'url:../../../../../resource/images/logoCbConecs.png';
import logoCbConecsSansContact from 'url:../../../../../resource/images/logoCbConecsSansContact.png';
import logoChequeELC from 'url:../../../../../resource/images/logoChequeELC.jpg';
import logoCupCic from 'url:../../../../../resource/images/logoCupCic.png';
import logoCupDinersDiscoverNatixis from 'url:../../../../../resource/images/logoCupDinersDiscoverNatixis.png';
import logoCupNatixis from 'url:../../../../../resource/images/logoCupNatixis.png';
import logoDccPlbs from 'url:../../../../../resource/images/logoDccPlbs.png';
import logoFexco from 'url:../../../../../resource/images/logoFexco.png';
import logoFintrax from 'url:../../../../../resource/images/logoFintrax.png';
import logoGlobalBlue from 'url:../../../../../resource/images/logoGlobalBlue.png';
import logoJCB from 'url:../../../../../resource/images/logoJCB.png';
import logoJcbVad from 'url:../../../../../resource/images/logoJcbVad.png';
import logoLaserCofinoga from 'url:../../../../../resource/images/logoLaserCofinoga.jpg';
import logoMultissime from 'url:../../../../../resource/images/logoMultissime.png';
import logoNatixis from 'url:../../../../../resource/images/logoNatixis.png';
import logoOptalion from 'url:../../../../../resource/images/logoOptalionLcl.png';
import logoP3Femv from 'url:../../../../../resource/images/logoP3Femv.png';
import logoPassCarrefour from 'url:../../../../../resource/images/logoPassCarrefour.png';
import logoPayludd from 'url:../../../../../resource/images/Payludd-Pace.png';
import logoPlbsGcb from 'url:../../../../../resource/images/logoPlbsGcb.png';
import logoPlbsPlus from 'url:../../../../../resource/images/logoPlbsPlus.png';
import logoPnfOzito from 'url:../../../../../resource/images/logoPnfOzito.png';
import logoPointVert from 'url:../../../../../resource/images/logoPointVert.png';
import logoPreAutoCM from 'url:../../../../../resource/images/logoPreAutoCM.png';
import logoQuasiCash from 'url:../../../../../resource/images/logoQuasiCash.png';
import logoSofinco from 'url:../../../../../resource/images/logoSofinco.png';
import logoTop3 from 'url:../../../../../resource/images/logoTop3.png';
import logoUPICA from 'url:../../../../../resource/images/logoUPICA.png';


const APPLICATIONS = {
    PAYLUDD: { logo: logoPayludd, name: 'PAYLUDD', entity: 'application.PAYLUDD' },
    ACCORDEMV: { logo: logoAccordEmv, name: 'ACCORDEMV', entity: 'application.ACCORDEMV' },
    DCCFCC: { logo: logoGlobalBlue, name: 'DCCFCC', entity: 'application.DCCFCC' },
    DCCPLBS: { logo: logoDccPlbs, name: 'DCCPLBS', mail: true, entity: 'application.DCCPLBS' },
    AMEX: { logo: logoAmericanExpress, name: 'AMEX', mail: true, entity: 'application.AMEX' },
    CBEMV: { logo: logoCB, name: 'CBEMV', mail: true, entity: 'application.CBEMV' },
    CONECS: { logo: logoCbConecs, name: 'CONECS', mail: true, entity: 'application.CONECS' },
    JCBEMV: { logo: logoJCB, name: 'JCBEMV', mail: true, entity: 'application.JCBEMV' },
    PLBSGCB: { logo: logoPlbsGcb, name: 'PLBSGCB', mail: true, entity: 'application.PLBSGCB' },
    CBVAD: { logo: logoCbVad, name: 'CBVAD', mail: true, entity: 'application.CBVAD' },
    CHEQUE_ELC: { logo: logoChequeELC, name: 'CHEQUE-ELC', entity: 'application.CHEQUE-ELC' },
    JCBVAD: { logo: logoJcbVad, name: 'JCBVAD', mail: true, entity: 'application.JCBVAD' },
    LASERCOFINOGA: { logo: logoLaserCofinoga, name: 'LASERCOFINOGA', entity: 'application.LASERCOFINOGA' },
    PNFOZITO: { logo: logoPnfOzito, name: 'PNFOZITO', entity: 'application.PNFOZITO' },
    PLBS_PLUS: { logo: logoPlbsPlus, name: 'PLBS+', mail: true, entity: 'application.PLBS+' },
    PLBS: { logo: logoDccPlbs, name: 'PLBS', mail: true, entity: 'application.PLBS' },
    CBCLESS: { logo: logoCBSansContact, name: 'CBCLESS', mail: true, entity: 'application.CBCLESS' },
    CONECSCLESS: { logo: logoCbConecsSansContact, name: 'CONECSCLESS', mail: true, entity: 'application.CONECSCLESS' },
    AMEXCLESS: { logo: logoAmericanExpressSansContact, name: 'AMEXCLESS', mail: true, entity: 'application.AMEXCLESS' },
    CBENSEIGNE: { logo: logoAurore, name: 'CBENSEIGNE', entity: 'application.CBENSEIGNE' },
    CASHAGENCE: { logo: logoCashAgence, name: 'CASHAGENCE', entity: 'application.CASHAGENCE' },
    CMCICSCHEME: { logo: logoCupCic, name: 'CMCICSCHEME', entity: 'application.CMCICSCHEME' },
    CUPNATIXIS: { logo: logoCupNatixis, name: 'CUPNATIXIS', entity: 'application.CUPNATIXIS' },
    NXSMULTI: { logo: logoCupDinersDiscoverNatixis, name: 'NXSMULTI', entity: 'application.NXSMULTI' },
    DCCFEXCO: { logo: logoFexco, name: 'DCCFEXCO', entity: 'application.DCCFEXCO' },
    DCCNATIXIS: { logo: logoNatixis, name: 'DCC NATIXIS', entity: 'application.DCC NATIXIS' },
    MULTISSIME: { logo: logoMultissime, name: 'MULTISSIME', entity: 'application.MULTISSIME' },
    OPTALION: { logo: logoOptalion, name: 'OPTALION', entity: 'application.OPTALION' },
    P3FEMV: { logo: logoP3Femv, name: 'P3FEMV', entity: 'application.P3FEMV' },
    PASSCAREFOUR: { logo: logoPassCarrefour, name: 'PASSCAREFOUR', entity: 'application.PASSCAREFOUR' },
    POINTVERT: { logo: logoPointVert, name: 'POINTVERT', entity: 'application.POINTVERT' },
    PREAUTOCMUT: { logo: logoPreAutoCM, name: 'PREAUTOCMUT', entity: 'application.PREAUTOCMUT' },
    QUASI_CASH: { logo: logoQuasiCash, name: 'QUASI-CASH', mail: true, entity: 'application.QUASI-CASH' },
    RELAISCE: { logo: '', name: 'RELAISCE', entity: 'application.RELAISCE' },
    FINTRAX: { logo: logoFintrax, name: 'FINTRAX', entity: 'application.FINTRAX' },
    SOFINCO: { logo: logoSofinco, name: 'SOFINCO', entity: 'application.SOFINCO' },
    ALMA: { logo: logoAlma, name: 'ALMA', manualUpdate: true, entity: 'application.ALMA' },
    UPI_CA_CONTACT: { logo: logoUPICA, name: 'UPI_CA_CONTACT', entity: 'application.UPI_CA_CONTACT' },
    UPI_CA_SANS_CONTACT: { logo: logoUPICA, name: 'UPI_CA_SANS_CONTACT', entity: 'application.UPI_CA_SANS_CONTACT' },
    UNKNOWN_APPLICATION: { logo: null, name: 'UNKNOWN_APPLICATION', entity: 'application.UNKNOWN_APPLICATION' },
    TOP3_3XCB: { logo: logoTop3, name: 'TOP3 3XCB', entity: 'application.TOP3_3XCB' }
};
const namespace = 'contract';

/**
 * Given an application code, return the application object with the entity and logo
 * @param {String} applicationCode Application code
 * @return {{logo: String, application: String}|null} Matching application or null
 */
const findApplicationFromCode = applicationCode => Object.values(APPLICATIONS).find(
    application => application.name === applicationCode
);


export { findApplicationFromCode, namespace };

export default APPLICATIONS;